import { requestCreator } from "../../common/actions/VisitApi";

import { CompanyValueFeature, EntitiesMap } from "../entities";

export interface CompanyValueFeaturesResponse {
  result: Array<CompanyValueFeature["feature"]>;
  entities: EntitiesMap;
}

export const requestToLoadCompanyValueFeatures = requestCreator<undefined, CompanyValueFeaturesResponse, Error>(() => ({
  path: "/api/v2/company_values/features",
  query: {
    fields: "feature,feature_cd,feature_title,feature_title_with_break,feature_category,feature_color,feature_help",
  },
  method: "GET",
}));

export interface MatchedCompaniesResponse {
  result: {
    companies: EntityId[];
    projects: EntityId[];
    company_value_features: EntityId[];
    selected_features: number[];
    total_companies_count: number;
    current_company: EntityId | null;
  };
  entities: EntitiesMap;
}

export interface SearchCompaniesParams {
  company_id?: EntityId;
  feature_cds: number[];
  occupation_type?: string;
  page?: number;
}

// Find companies by company values
export const requestToSearchCompanies = requestCreator<SearchCompaniesParams, MatchedCompaniesResponse, Error>(
  query => {
    const data: any = {};
    if (query.company_id) {
      data.company_id = query.company_id;
    }
    if (query.feature_cds && query.feature_cds.length) {
      data.feature_cds = query.feature_cds.join();
    }
    if (query.occupation_type) {
      data.occupation_type = query.occupation_type;
    }
    if (query.page) {
      data.page = query.page;
    }
    return {
      path: "/values.json",
      query: data,
      method: "GET",
    };
  }
);



// WEBPACK FOOTER //
// ./frontend/src/company_values/api/index.ts